import { css } from 'lit';
export default css `
  :host {
    display: block;
    --private-button-size: 20px;
    --private-between-button-space: 8px;
    --private-selection-shadow-size: 4px;
    --private-hidden-input-adjustment: 1px;
  }

  sl-radio-button {
    position: relative;
    display: block;
    margin: var(--private-selection-shadow-size)
      calc(var(--private-between-button-space) / 2 + var(--private-selection-shadow-size));
    margin-top: calc(var(--private-selection-shadow-size) - var(--private-hidden-input-adjustment));
  }

  sl-radio-button:first-child {
    margin-left: var(--private-selection-shadow-size);
  }

  sl-radio-button:last-child {
    margin-right: var(--private-selection-shadow-size);
  }

  sl-radio-button::part(button) {
    width: var(--private-button-size);
    height: var(--private-button-size);
    line-height: var(--private-button-size);
    background-color: var(--private-button-color);
    border-radius: 50%;
    border: 0;
    box-shadow: var(--amityeko-elevation-3);
  }

  sl-radio-button::part(button)::after {
    border-left: none;
  }

  sl-radio-button:hover::part(button) {
    box-shadow: 0 0 0 var(--private-selection-shadow-size) var(--amityeko-color-primary-2);
  }

  sl-radio-button::after {
    content: ' ';
    position: absolute;
    display: none;
    top: calc(var(--private-button-size) / 2 - 3px + var(--private-hidden-input-adjustment));
    left: calc(var(--private-button-size) / 2 - 3px);
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #ffffff;
  }

  sl-radio-button.button--checked::after {
    display: block;
  }

  .button--white::after {
    top: calc(
      var(--private-button-size) / 2 - 4px + var(--private-hidden-input-adjustment)
    ) !important;
    left: calc(var(--private-button-size) / 2 - 4px) !important;
    border: 1px solid var(--amityeko-color-gray-6);
  }

  sl-radio-group {
    display: flex;
    align-items: center;
  }

  amityeko-tg-label-two {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    width: 84px;
  }

  .radio-buttons-wrapper {
    display: flex;
    flex: 1 1 auto;
  }
`;
//# sourceMappingURL=styles.js.map